<ng-container [formGroup]="eventVenue">
  <mdb-form-control class="form-fill">
    <app-mdbp-input #name mdbInput formControlName="name" label='Venue Name'></app-mdbp-input>
  </mdb-form-control>
  
  <mdb-form-control class="form-fill appGoogleMapsAutocomplete d-flex">
      <app-mdb-input-google-maps-autocomplete
          id="google-maps-autocomplete"
          mdbInput
          autocomplete="address"
          label="Address"
          class="d-flex w-100"
          [formControl]="addressControl"
      ></app-mdb-input-google-maps-autocomplete>
  </mdb-form-control>

  <mdb-form-control class="form-fill">
    <app-mdbp-input #name mdbInput formControlName="unitNum" label='Unit# (optional)'></app-mdbp-input>
  </mdb-form-control>
</ng-container>
